import {platform} from '../services'

export function checkExtension(ext, installed, noSupport, doDownload) {
  // check if already installed
  if (Array.isArray(ext.cssFlags) && ext.cssFlags.find((flag) => document.querySelector(flag))) return installed()

  // get url and check if browser support ext
  const url = ext.browsers && ext.browsers[platform?.browser?.alias]

  if (!url) {
    return noSupport()
  } else {
    return doDownload(url)
  }
}
